import React from "react";
import moment from 'moment';
import {utils_tool, component_tool, framework_tool} from '@/tool';

let {WizModal} = component_tool;
import Editor from './editor';
import CheckResourcesCount from './checkResourcesCount';

let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'interactLiveResources';

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
let ref;
let ref_;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "账号",
    name: "searchUserEmail",
    searchItem: {}
  },
  {
    title: "名称",
    name: "searchFirstName",
    searchItem: {}
  },
  {
    title: "用户编码",
    name: "searchUserCode",
    searchItem: {}
  },
  {
    title: "第三方用户ID",
    name: "userId",
    tableItem: {
      width: 200,
    },
    searchItem: {}
  },
  {
    title: "账号",
    name: "userEmail",
    tableItem: {
      width: 150,
    },
  },
  {
    title: "名称",
    name: "firstName",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "用户编码",
    name: "userCode",
    tableItem: {
      width: 200,
    },
  },
  {
    title: "帐户使用类型",
    name: "type",
    dict: [
      {code: 0, codeName: "zoom资源帐户"},
      {code: 1, codeName: "远程评估"},
      {code: 2, codeName: "直播课堂/远程认证"},
    ],
    tableItem: {
      width: 150,
    },
    searchItem: {
      type: "select"
    },
  },
  {
    title: "状态",
    name: "status",
    dict: [
      {code: 0, codeName: "禁用"},
      {code: 1, codeName: "激活"},
    ],
    tableItem: {
      width: 80,
    },
    searchItem: {
      type: "select"
    },
  },
  {
    title: "资源密码",
    name: "password",
    tableItem: {
     // width: 120,
    },
  },
  {
    title: "到期时间",
    name: "expirationTime",
    tableItem: {
      width: 120,
      render: (text, record) => {
        return formatterDate(text)
      }
    },
  },
];

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        btnAccessCheck: false,
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            return value
          },
          buttonSort: ['batchCreateZoomUserResources'],
          buttons: [
            {
              key: 'batchCreateZoomUserResources',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'editorBatchCreateZoomUserResources',
                  modalParams: {
                    title: '新增慧课堂资源账号',
                    style: {minWidth: 700},
                    diy: (e) => {
                      let editorProps = {
                        key: 'editorBatchCreateZoomUserResources_'+self.state.AddTimestamp,
                        ref: r => r && r.getWrappedInstance(),
                        editorSuccess: () => {
                          self.setState({AddTimestamp: new Date().getTime()})
                        },
                        ...e
                      }
                      return <Editor {...editorProps} />
                    },
                    onCancel: () => {
                      self.setState({AddTimestamp: new Date().getTime()})
                    },
                    footer: false,
                    width: 680
                  },
                }
              }
            },
          ]
        },
        modalFormProps: {
          key: "modal123",
          params: {
            modalParams: {
              title: "Modal",
              children: "Bla bla123 .."
            }
          }
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['open','enableOrDisable','liveList'],
        rowOperateView: [
          {
            key: 'open',
            custom: true,
            params: {icon: "into", children: "编辑", type: "info"},
            textFormat: {
              recordKey: 'status',
            },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'editorAloneBatchCreateZoomUserResources_'+new Date().getTime(),
                modalParams: {
                  title: '操作',
                  style: {minWidth: 700},
                  diy: (e) => {
                    const {status} = e.record;
                    let statusUpdate = 'open';
                    if (status===1){
                      statusUpdate = 'update'
                    }
                    let editorProps = {
                      operationMode:'alone',
                      operationUpdateMode:statusUpdate,
                      editorSuccess: () => {
                        self.setState({AddTimestamp: new Date().getTime()})
                      },
                      ...e
                    }
                    return <Editor {...editorProps}
                                        ref={(r) => {
                                          ref_ = r && r.getWrappedInstance();
                                        }}
                                        key={'BatchEditor_' + e.record.id +'_'+ self.state.AddTimestamp}
                    />
                  },
                  onOk: () => {
                    ref_._ok();
                  },
                  onCancel: () => {
                    self.setState({AddTimestamp: new Date().getTime()})
                    ref_._doInitParams();
                  },
                  footer: false,
                  width: 680
                },
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '你确定要激活选中的资源账号吗？'
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      record: record,
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              },
            },
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'status',
              dirt: {'1': '禁用', '0': '启用'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let status = record['status'] === 0 || record['status'] === 1 ? "启用" : "禁用"
                const content = `你确定要${status}该资源账号吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status:  record['status'] === 0 ? 1:0,
                      idList: [record['id']]
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
          },
          {
            key: "liveList",
            custom: true,
            params: {children: "直播列表"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interactLiveHktResources/liveHktList"
              }
            }
          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          update: true,
          look: true
        }
      }
    }
  };
};

const apis = {
  list: {
    path: `${componentName}/entityByPage`,
    payload: {
      key: `${componentName}@entityByPage`,
      apiParams: {pageNum: 1, pageSize: 10,channel:2}
    }
  },
  // batchCreateZoomUserResources: {
  //   path: `${componentName}/add`,
  //   payload: {
  //     key: `${componentName}@batchCreateZoomUserResources`,
  //     apiParams: {}
  //   }
  // },
  update: {
    path: `${componentName}/upd`,
    payload: {
      key: `${componentName}@upd`,
      apiParams: {}
    }
  },

  updateStatus: {
    path: `${componentName}/updateResourcesState`,
    payload: {
      key: `${componentName}@updateResourcesState`,
      apiParams: {}
    }
  },
}
let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
